import { parsePhoneNumber } from 'react-phone-number-input'

export const normalizeCheckInUploadPhone = (value) => {
	const raw = value === null || value === undefined ? '' : String(value).trim()
	if (!raw) return null

	// Preserve malformed values instead of extracting a different number from them.
	if (!/^\+?[\d\s().-]+$/.test(raw)) return raw

	const digits = raw.replace(/\D/g, '')
	const candidate =
		!raw.startsWith('+') && digits.length > 10 ? `+${digits}` : raw
	const phone = parsePhoneNumber(candidate, 'US')
	return phone?.isValid() ? phone.number : raw
}
